import { c as _c } from "react/compiler-runtime";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { faAddressCard, faStar } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { WaveDropMetaRow } from "./WaveDropMetaRow";
import { WaveDropVoteSummary } from "./WaveDropVoteSummary";
interface MemesDropSummarySectionProps {
  readonly drop: ExtendedDrop;
  readonly title: string;
  readonly description: string;
  readonly artworkMimeType?: string | undefined;
  readonly isWinner: boolean;
  readonly isVotingEnded: boolean;
  readonly canShowVote: boolean;
  readonly manualOutcomes: string[];
  readonly nicTotal: number;
  readonly repTotal: number;
  readonly onVoteClick: () => void;
}
export function MemesDropSummarySection(t0) {
  const $ = _c(30);
  const {
    drop,
    title,
    description,
    artworkMimeType,
    isWinner,
    isVotingEnded,
    canShowVote,
    manualOutcomes,
    nicTotal,
    repTotal,
    onVoteClick
  } = t0;
  let t1;
  if ($[0] !== canShowVote || $[1] !== drop || $[2] !== isVotingEnded || $[3] !== isWinner || $[4] !== onVoteClick) {
    t1 = <div className="tw-mb-8 tw-flex tw-justify-center"><WaveDropVoteSummary drop={drop} isWinner={isWinner} isVotingEnded={isVotingEnded} canShowVote={canShowVote} onVoteClick={onVoteClick} /></div>;
    $[0] = canShowVote;
    $[1] = drop;
    $[2] = isVotingEnded;
    $[3] = isWinner;
    $[4] = onVoteClick;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== title) {
    t2 = <h1 className="tw-mb-4 tw-text-lg tw-font-bold tw-tracking-tight tw-text-white sm:tw-text-2xl">{title}</h1>;
    $[6] = title;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== description) {
    t3 = description && <p className="tw-mb-0 tw-text-sm tw-text-white/60 lg:tw-text-md">{description}</p>;
    $[8] = description;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== t2 || $[11] !== t3) {
    t4 = <div className="tw-mb-6">{t2}{t3}</div>;
    $[10] = t2;
    $[11] = t3;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== manualOutcomes) {
    t5 = manualOutcomes.length > 0 && <><span className="tw-text-white/40">·</span>{manualOutcomes.map(_temp)}</>;
    $[13] = manualOutcomes;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== nicTotal) {
    t6 = !!nicTotal && <><span className="tw-text-white/40">·</span><FontAwesomeIcon icon={faAddressCard} className="tw-h-4 tw-w-4 tw-text-white/40" /><span className="tw-text-sm tw-text-white/60">{nicTotal} NIC</span></>;
    $[15] = nicTotal;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== repTotal) {
    t7 = !!repTotal && <><span className="tw-text-white/40">·</span><FontAwesomeIcon icon={faStar} className="tw-h-4 tw-w-4 tw-text-white/40" /><span className="tw-text-sm tw-text-white/60">{repTotal} Rep</span></>;
    $[17] = repTotal;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== artworkMimeType || $[20] !== drop || $[21] !== isWinner || $[22] !== t5 || $[23] !== t6 || $[24] !== t7) {
    t8 = <WaveDropMetaRow drop={drop} isWinner={isWinner} mimeType={artworkMimeType}>{t5}{t6}{t7}</WaveDropMetaRow>;
    $[19] = artworkMimeType;
    $[20] = drop;
    $[21] = isWinner;
    $[22] = t5;
    $[23] = t6;
    $[24] = t7;
    $[25] = t8;
  } else {
    t8 = $[25];
  }
  let t9;
  if ($[26] !== t1 || $[27] !== t4 || $[28] !== t8) {
    t9 = <div className="tw-mt-4 tw-px-4 sm:tw-px-6 md:tw-mt-6 xl:tw-px-20"><div className="tw-mx-auto tw-w-full tw-max-w-3xl">{t1}{t4}{t8}</div></div>;
    $[26] = t1;
    $[27] = t4;
    $[28] = t8;
    $[29] = t9;
  } else {
    t9 = $[29];
  }
  return t9;
}
function _temp(outcome) {
  return <span key={outcome} className="tw-text-sm tw-text-amber-400/70">{outcome}</span>;
}